var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFg60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.64,0C5.67,0,0,5.67,0,12.64s5.67,12.64,12.64,12.64,12.64-5.67,12.64-12.64S19.62,0,12.64,0Zm0,1.41c6.2,0,11.24,5.04,11.24,11.24,0,1.42-.28,2.78-.76,4.03l-6.27-3.37c.03-.22.07-.44.07-.66,0-2.36-1.91-4.27-4.27-4.27s-4.27,1.91-4.27,4.27c0,.23.03.44.07.66l-6.27,3.37c-.48-1.25-.76-2.61-.76-4.03C1.41,6.45,6.45,1.41,12.64,1.41Zm0,22.47c-3.77,0-7.11-1.87-9.14-4.73l6.27-3.37c.76.7,1.76,1.13,2.88,1.13s2.12-.44,2.88-1.13l6.27,3.37c-2.04,2.86-5.37,4.73-9.14,4.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.58,27.69h-3.09v-1.2c0-.26-.21-.47-.47-.47h-1.15c-.26,0-.47.21-.47.47v1.2h-3.14l-.82-1.43c-.08-.14-.29-.14-.38,0l-.82,1.43h-3.14v-1.2c0-.26-.21-.47-.47-.47h-1.15c-.26,0-.47.21-.47.47v1.2h-3.14l-.82-1.43c-.08-.14-.29-.14-.38,0l-.82,1.43H.7c-.39,0-.7.32-.7.7s.32.7.7.7h.76v.43c0,.26.21.47.47.47h.66c.26,0,.47-.21.47-.47v-.43h3.59v.43c0,.26.21.47.47.47h.66c.26,0,.47-.21.47-.47v-.43h3.59v.43c0,.26.21.47.47.47h.66c.26,0,.47-.21.47-.47v-.43h3.59v.43c0,.26.21.47.47.47h.66c.26,0,.47-.21.47-.47v-.43h3.59v.43c0,.26.21.47.47.47h.66c.26,0,.47-.21.47-.47v-.43h.74c.39,0,.7-.32.7-.7s-.32-.7-.7-.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFg60);
export default __webpack_public_path__ + "static/media/FG60.d0b06a228c209dddcfc259cdb636983a.svg";
export { ForwardRef as ReactComponent };